import React, { FC } from "react";

// card component
import OverViewCard from "./card/Card";


// icon
import { CompleteOrderIcon } from "../../../../assets/svg/dashboard/CompleteOrderIcon";
import { RunningOrderIcon } from "../../../../assets/svg/dashboard/RunningOrderIcon";
import { AggregatorFarmerIcon } from "../../../../assets/svg/dashboard/AggregatorFarmerIcon";
import { MyFarmerIcon } from "../../../../assets/svg/dashboard/MyFarmerIcon";
import { TotalCustomerIcon } from "../../../../assets/svg/dashboard/TotalCustomerIcon";
import { LoadingComponent } from "../../../components/common/Loading";
import { ErrorComponent } from "../../../components/common/ErrorComponent";

interface OverViewProps{
    data:any 
    loading:boolean;
    error:string
}

export const OverView:FC<OverViewProps> = ({data,loading,error}) => {

  if(loading){
    return <LoadingComponent/>
  }

  if (error){
    return <ErrorComponent message={error}/>
  }

  return (
   
      <div className="row gy-5" style={{marginTop:1}}>
        <div className="col-lg-3 col-md-6">
          <OverViewCard
            bgColor="#FFE2E5"
            textColor="#FA5A7D"
            icon={<CompleteOrderIcon />}
            title="Total My Farmer"
            content={data.myTotalFarmers}
          />
        </div>
        <div className="col-lg-3 col-md-6">
          <OverViewCard
            bgColor="#FFF4DE"
            textColor="#FF9975"
            icon={<RunningOrderIcon />}
            title="Total My Aggregator Farmer"
            content={data.aggregatorTotalFarmers}
          />
        </div>
        <div className="col-lg-3 col-md-6">
          <OverViewCard
            bgColor="#DCFCE7"
            textColor="#3CD856"
            icon={<AggregatorFarmerIcon />}
            title="Total Customer"
            content={data.totalCustomers}
          />
        </div>
        <div className="col-lg-3 col-md-6">
          <OverViewCard
            bgColor="#F3E8FF"
            textColor="#BF83FF"
            icon={<MyFarmerIcon />}
            title="Total Orders Complete"
            content={data.totalCompletedOrders}
          />
        </div>
        <div className="col-lg-3 col-md-6">
          <OverViewCard
            bgColor="#FFF4DE"
            textColor="#FF9975"
            icon={<TotalCustomerIcon />}
            title="Total Running Order"
            content={data.totalRunningOrders}
          />
        </div>
      </div>
  
  );
};
